<content-default>
    <ng-container content>
        <div class="row">
            <div class="col-12">
                <div
                    class="m-card"
                    style="padding: 15px; margin: 15px"
                >
                    <h1>
                        {{
                            (online ? "serviceStatus.text" : "serviceStatus.userOffline")
                                | translate: { productName: websiteService.getProductName() }
                        }}
                    </h1>

                    <div>
                        <p
                            [translate]="'serviceStatus.nextRetry'"
                            [translateParams]="{ seconds: pollTimer }"
                        ></p>

                        @if (healthCheck && pollTimer !== 0) {
                            <table>
                                <thead>
                                    <tr>
                                        <th>Service</th>
                                        <th>Status</th>
                                        <th>Duration</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (entry of healthCheck.entries | keyvalue; track entry.key) {
                                        <tr>
                                            <td>{{ entry.key }}</td>
                                            <td>{{ entry.value.status }}</td>
                                            <td>{{ entry.value.duration }}</td>
                                            <td>{{ entry.value.description || "N/A" }}</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        }
                        @if (pollTimer === 0) {
                            <app-loading-spinner />
                        }
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</content-default>
